import React, { Component } from 'react';
import { Alert } from 'reactstrap';

/**
 * AlertBanner Component
 *
 * Displays a banner notification when user arrives via email alert link.
 * Shows the service name and alert ID, with a dismiss button.
 *
 * Props:
 * - serviceName: string - Name of the service that triggered the alert
 * - alertId: number - ID of the alert from ServiceAlerts table
 * - onDismiss: function - Callback when user dismisses the banner
 */
class AlertBanner extends Component {
    render() {
        const { serviceName, alertId, onDismiss } = this.props;

        if (!serviceName || !alertId) {
            return null;
        }

        return (
            <Alert
                color="warning"
                isOpen={true}
                toggle={onDismiss}
                className="alert-banner mb-3"
                style={{
                    borderLeft: '4px solid #ffc107',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}
            >
                <div className="d-flex align-items-center">
                    <div className="mr-3" style={{ fontSize: '24px' }}>
                        <i className="fa fa-envelope"></i>
                    </div>
                    <div className="flex-grow-1">
                        <strong>Email Alert:</strong> You were redirected from an email alert for{' '}
                        <strong>{serviceName}</strong>
                        <br />
                        <small className="text-muted">
                            Alert ID: {alertId} • Scroll down to view service details
                        </small>
                    </div>
                    <div className="ml-3">
                        <button
                            className="btn btn-sm btn-outline-secondary"
                            onClick={onDismiss}
                            aria-label="Dismiss alert banner"
                        >
                            Dismiss
                        </button>
                    </div>
                </div>
            </Alert>
        );
    }
}

export default AlertBanner;
